<fc-search-many-input
  [label]="'REQUESTERS.LABEL' | translate"
  [control]="control"
  [desiredStyle]="desiredStyle"
  [search]="search"
  [displayWith]="displayWith"
></fc-search-many-input>
